import { render, staticRenderFns } from "./venueDetails.vue?vue&type=template&id=178f47a3&scoped=true&"
import script from "./venueDetails.vue?vue&type=script&lang=js&"
export * from "./venueDetails.vue?vue&type=script&lang=js&"
import style0 from "./venueDetails.vue?vue&type=style&index=0&id=178f47a3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178f47a3",
  null
  
)

export default component.exports